module.exports = __webpack_public_path__ + "MaterialIcons-Regular.woff2";


//////////////////
// WEBPACK FOOTER
// ./~/material-design-icons/iconfont/MaterialIcons-Regular.woff2
// module id = 87
// module chunks = 0